import { zodResolver } from '@hookform/resolvers/zod';
import { Flex } from 'antd';
import classNames from 'classnames';
import { useForm } from 'react-hook-form';

import { Button, ButtonVariant, Icon, Informer, Modal } from '@/shared/ui';
import { FormCheckbox } from '@/shared/ui/Checkbox/FormCheckbox';

import { Breakpoints, useMediaQuery } from '@/hooks/useMediaQuery';

import { InsuranceOrder } from '@/modules/bia/shared/model/types';

import { base64ToPdfBlob } from '@/helpers/fileHelper';
import { saveFileFromBlob } from '@/helpers/saveFileFromBlob';

import { insuranceOrderPreviewModalSchema } from '../model/schemas';
import { InsuranceOrderPreviewModalSchema } from '../model/types';

interface InsuranceOrderPreviewModalProps {
  isOpen: boolean;
  insuranceOrder: InsuranceOrder;
  onContinue: () => void;
  onClose: () => void;
  onCancel: () => void;
}

export const InsuranceOrderPreviewModal: React.FC<InsuranceOrderPreviewModalProps> = ({
  isOpen,
  insuranceOrder,
  onContinue,
  onClose,
  onCancel,
}) => {
  const { control, watch } = useForm<InsuranceOrderPreviewModalSchema>({
    resolver: zodResolver(insuranceOrderPreviewModalSchema),
  });
  const isMobileSize = useMediaQuery(Breakpoints.LG);

  const confirmOffer = watch('confirmOffer');

  return (
    <Modal
      open={isOpen}
      title="Пропозиція"
      size="lg"
      onCancel={onClose}
      closable
      footer={
        <>
          <Flex justify={isMobileSize ? 'initial' : 'space-between'} vertical={isMobileSize} gap={15}>
            <Flex vertical={isMobileSize} gap={15}>
              <Button variant={ButtonVariant.SECONDARY} onClick={onCancel}>
                Скасувати
              </Button>

              <Button
                variant={ButtonVariant.SECONDARY}
                onClick={() => {
                  saveFileFromBlob(insuranceOrder.file_name, base64ToPdfBlob(insuranceOrder.file));
                }}
              >
                <Flex gap={8}>
                  <Icon name="download" />
                  Завантажити
                </Flex>
              </Button>
            </Flex>

            <Button disabled={!confirmOffer} onClick={onContinue}>
              Далі
            </Button>
          </Flex>
        </>
      }
    >
      <Flex vertical gap={16}>
        <div
          style={{
            position: 'relative',
            width: '100%',
            height: classNames({
              '620px': !isMobileSize,
              '360px': isMobileSize,
            }),
          }}
        >
          <iframe
            title="pdf preview"
            src={`data:application/pdf;base64,${insuranceOrder.file}`}
            height="100%"
            width="100%"
          />
        </div>

        <Informer
          borderColor="dark-yellow"
          header={{
            color: 'red',
            text: 'Зверніть увагу!',
          }}
          icon={{
            name: 'attention',
            color: 'red',
          }}
          text={{
            color: 'black',
            text: 'Це попереднє оформлення. Для укладення договору потрібна оплата',
          }}
        />

        <FormCheckbox
          name="confirmOffer"
          control={control}
          label="Я ознайомився(лась) та підтверджую дану пропозицію"
        />
      </Flex>
    </Modal>
  );
};
